<template>
  <section class="home-statics-container">
    <h2 class="home-title">숫자로 보는 서베이지</h2>

    <div class="home-statics-grid">
      <div class="statics-card statics-card--highlight">
        <span class="statics-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
          </svg>
        </span>
        <span class="statics-label">누적 설문</span>
        <span class="statics-value">2,684</span>
      </div>

      <div class="statics-card">
        <span class="statics-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </span>
        <span class="statics-label">참여 가능 패널</span>
        <span class="statics-value">1,008명</span>
      </div>

      <div class="statics-card">
        <span class="statics-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </span>
        <span class="statics-label">평균 수집 시간</span>
        <span class="statics-value">18시간</span>
      </div>

      <div class="statics-card">
        <span class="statics-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </span>
        <span class="statics-label">서비스 만족도</span>
        <span class="statics-value">4.7 / 5</span>
      </div>
    </div>

    <p class="home-statics-note">
      참여 가능 패널은 최근 30일 안에 응답한 활성 패널 기준이에요. 전체 가입 패널은 1,311명이에요.
    </p>
  </section>
</template>

<script>
export default {
  name: 'HomeStatics'
}
</script>

<style scoped>
.home-statics-container {
  width: 100%;
  box-sizing: border-box;
  padding: 80px 24px;
  font-family: var(--font-sans);
}

.home-title {
  margin: 0 0 var(--space-6) 0;
  font-size: 34px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}

.home-statics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--space-4);
}

.statics-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  padding: 18px 20px;
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-lg);
  box-sizing: border-box;
}

.statics-card--highlight {
  background-color: var(--surface-selected);
  border-color: var(--green-300);
}

.statics-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--green-500);
}

.statics-icon svg {
  width: 100%;
  height: 100%;
}

.statics-label {
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}

.statics-value {
  font-size: 28px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
}

.home-statics-note {
  margin: var(--space-6) 0 0 0;
  font-size: 13px;
  font-weight: var(--font-weight-regular);
  color: var(--text-muted);
  text-align: left;
}

@media (max-width: 560px) {
  .home-title {
    font-size: 24px;
  }

  .home-statics-grid {
    grid-template-columns: 1fr 1fr;
    gap: var(--space-3);
  }

  .statics-card {
    padding: var(--space-4);
  }

  .statics-value {
    font-size: 22px;
  }
}
</style>
